import ProductCategoryView from "./ProductCategoryView";

export default ProductCategoryView;
